<template>
  <div v-for="(value, key ) in FILTER_PROPS_MAP" :key="key">
    <WishListCategory :list="lists[key]" :listKey="key" :listName="value" @selectedItem="(item) => selectedItem = item" />
  </div>
</template>

<script>
import WishListCategory from './WishListCategory.vue'
import { FILTER_PROPS_MAP } from '@/constants';
import JSConfetti from 'js-confetti'
import { onCheckToggle } from '../firebase';

const confetti = new JSConfetti()


export default {
  name: 'WishList',
  props: {
    list: Object,
    filter: String
  },
  components: {
    WishListCategory
  },

  data() {
    return {
      FILTER_PROPS_MAP,
      selectedItem: {}
    }
  },
  watch: {
    async selectedItem() {
      if (!this.selectedItem.checked) {
        confetti.addConfetti({
          confettiRadius: 6,
          confettiNumber: 500,
        })
      }
      onCheckToggle(this.selectedItem)

    }
  },
  computed: {
    lists() {
      const listsData = {};
      for (let prop in FILTER_PROPS_MAP) {
        listsData[prop] = [];
      }

      for (let prop in this.list) {
        const item = Object.assign({ id: prop }, this.list[prop]);

        if (item.checked) {
          listsData[item.isFor || 'all'].push(item);
        } else {
          listsData[item.isFor || 'all'].unshift(item);
        }
      }

      return listsData;
    }
  }
}
</script>

